import React, { useRef } from 'react'
import "../index.css"
import emailjs from "@emailjs/browser";

const Form = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault(); //prevents page from reloading

        emailjs.sendForm('service_147872u','template_lk4bvcr',form.current, 'xufkUrbav_tXKNCfT')
        .then((result) => {
            alert("message submitted successfully!", result.status, result.text )
        }, (error) =>{
            alert("Oops! failed to submit message..", error) 
        });

        form.current.reset();
    };

  return (
    <form ref={form} onSubmit={sendEmail} className="form">
      <h1 className="form-title">Message me</h1>
      <div className="form-title-underline"></div>
      <div className="text-and-input"> 
        <div className="form-inputs">
          <input type="text" placeholder="your name" name="sender_name" className="input-text" required/>
          <input type="email" placeholder="email address" name="sender_email" className="input-email" required/>
          <input type="text" placeholder="subject" name="subject" className="input-text" required/>
        </div>
        <div className='form-message'>
          <textarea placeholder="message.." rows="4" cols="20" name="message" className="textarea" required/>
        </div>
      </div>
      
      <input type='submit' value="send message" className="submit-btn" />
    </form>
  )
}

export default Form